module.exports = __webpack_public_path__ + "img/serifnew_box30.2ff80eef.jpg";